import React from 'react';
import '../../scss/Table.scss';
import 'font-awesome/css/font-awesome.min.css';


export default class Table extends React.Component {
  constructor(props) {
    super(props);
    this.maxRows = 10;
  }

  render_old() {
    return (<div className="tableContainer">
          {this.generateRows()}
    </div>)
  }

  generateRows_old() {
    let data = this.props.screen.rowset.rows;
    //slicedData = [];
    let tdText = 'tdText';
    if(data.length < 1){
      tdText = 'tdText noResult';
      data = [];
      data[0] = [];
      data[0][0] = '';
      data[0][1] = 'Keine Treffer';
    }
    let generatedRows = [...Array(this.maxRows)].map((x, i) => {

      return <div className="tableRow" key={i+this.props.screen.dataSource}>
        <span className="tdStatus" key={i + '_status_'+ this.props.screen.dataSource}>
            <i className={i < data.length && data[i][2] !== undefined
                ? 'fa fa-circle colorStatus' + data[i][2]
                : ''}></i>
            </span>
        <span className="tdIdenfify" key={i + '_id_'+ this.props.screen.dataSource}>{
            i < data.length
              ? data[i][0]
              : ''
          }</span>
        <span className={tdText} key={i + '_text_'+ this.props.screen.dataSource}>{
            i < data.length
              ? data[i][1]
              : ''
          }</span>
      </div>;

    })
    return generatedRows;
  }


  render() {
    return (<table className="tableContainer">
          <tbody>
          {this.generateRows()}
        </tbody>
    </table>)
  }

  generateRows() {
    let data = this.props.screen.rowset.rows;
    //slicedData = [];
    let tdText = 'tdText';
    if(data.length < 1){
      tdText = 'tdText noResult';
      data = [];
      data[0] = [];
      data[0][0] = '';
      data[0][1] = 'Keine Treffer';
    }
    let generatedRows = [...Array(data.length)].map((x, i) => {

      return <tr className="tableRow" key={i+this.props.screen.dataSource}>
        <td className="tdIdenfify" key={i + '_id_'+ this.props.screen.dataSource}>
          <i className={i < data.length && data[i][2] !== undefined
              ? 'fa fa-circle statusDot colorStatus' + data[i][2]
              : ''}></i>
          {
            i < data.length
              ? data[i][0]
              : ''
          }</td>
        <td className={tdText} key={i + '_text_'+ this.props.screen.dataSource}>{
            i < data.length
              ? data[i][1]
              : ''
          }</td>
      </tr>;

    })
    return generatedRows;
  }
}



// WEBPACK FOOTER //
// ./src/components/Table/index.js